// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__TuM-U","content":"Dialog_content__nioDd"};